import { render, staticRenderFns } from "./authority-list.vue?vue&type=template&id=6f0e7884&scoped=true"
import script from "./authority-list.vue?vue&type=script&lang=js"
export * from "./authority-list.vue?vue&type=script&lang=js"
import style0 from "./authority-list.vue?vue&type=style&index=0&id=6f0e7884&prod&scoped=true&lang=scss"
import style1 from "./authority-list.vue?vue&type=style&index=1&id=6f0e7884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e7884",
  null
  
)

export default component.exports